var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1666 0.416687H4.83329C2.33329 0.416687 0.666626 1.66669 0.666626 4.58335V10.4167C0.666626 13.3334 2.33329 14.5834 4.83329 14.5834H13.1666C15.6666 14.5834 17.3333 13.3334 17.3333 10.4167V4.58335C17.3333 1.66669 15.6666 0.416687 13.1666 0.416687ZM13.5583 5.49169L10.95 7.57502C10.4 8.01669 9.69996 8.23335 8.99996 8.23335C8.29996 8.23335 7.59163 8.01669 7.04996 7.57502L4.44163 5.49169C4.17496 5.27502 4.13329 4.87502 4.34163 4.60835C4.55829 4.34169 4.94996 4.29169 5.21663 4.50835L7.82496 6.59169C8.45829 7.10002 9.53329 7.10002 10.1666 6.59169L12.775 4.50835C13.0416 4.29169 13.4416 4.33335 13.65 4.60835C13.8666 4.87502 13.825 5.27502 13.5583 5.49169Z",
    fill: "#202020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.7fc981c2bce1dce141a7e1903ebf1dc1.svg";
export { ForwardRef as ReactComponent };